import { all, put, select, take, takeEvery, takeLatest } from "redux-saga/effects";

import notificationService from "../../../services/notifications";
import {
  getNotificationsStart,
  getNotificationsSuccess,
  getNotificationsFailure,
  readNotificationStart,
  readNotificationSuccess,
  readNotificationFailure,
} from "../../redux/notifications/notifications";
import { showErrorMessage } from "../../redux/toast";
import { getUserProfileDetailsSuccess } from "../../redux/profile/myProfile";

function* notificationsWatcher() {
  yield takeEvery(getNotificationsStart.type, notificationsWorker);
}

function* notificationsWorker(action) {
  try {
    const { pageNumber = 1, limit = 10 } = action.payload || {};
    let parentId = yield select((state) => state.myProfile?.userDetails?.parentId);
    if (!parentId) {
      const profileAction = yield take(getUserProfileDetailsSuccess.type);
      parentId = profileAction.payload?.parentId;
    }
    const response = yield notificationService.getNotifications({ pageNumber, limit, parentId });

    if (response && !response.error) {
      yield put(getNotificationsSuccess(response));
    } else if (response?.error) {
      yield put(showErrorMessage({ msg: response.error.message || "Failed to fetch notifications" }));
      yield put(getNotificationsFailure(response.error));
    }
  } catch (error) {
    yield put(showErrorMessage({ msg: error.message || "An error occurred while fetching notifications" }));
    yield put(getNotificationsFailure(error));
  }
}

function* readNotificationWatcher() {
  yield takeLatest(readNotificationStart.type, readNotificationWorker);
}

function* readNotificationWorker(action) {
  try {
    // Always send { notificationIds: [...] }
    const payload = action.payload.notificationIds
      ? { notificationIds: action.payload.notificationIds }
      : { notificationIds: [action.payload.notificationId] };
    const { data, error } = yield notificationService.readNotification(payload);
    if (data) {
      yield put(readNotificationSuccess({ notificationIds: payload.notificationIds, ...data }));
    }
    if (error) {
      yield put(showErrorMessage({ msg: error.message || "Failed to mark notification as read" }));
      yield put(readNotificationFailure(error));
    }
  } catch (error) {
    yield put(showErrorMessage({ msg: error.message || "An error occurred while marking notification as read" }));
    yield put(readNotificationFailure(error));
  }
}

export default function* rootNotificationSaga() {
  yield all([
    notificationsWatcher(),
    readNotificationWatcher(),
  ]);
}
